import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"

type EmailListFieldProps = {
  id: string
  label: string
  help?: string
  placeholder?: string
  value: string
  onChange: (value: string) => void
}

/**
 * Multi-line textarea for a newline/comma-separated list of email addresses or
 * domains. Shared by the Flow email "default recipients" and "allowed external
 * recipients" fields.
 */
export function EmailListField({
  id,
  label,
  help,
  placeholder,
  value,
  onChange,
}: EmailListFieldProps) {
  return (
    <div className="grid gap-1.5">
      <Label className="text-sm" htmlFor={id}>
        {label}
      </Label>
      {help ? <p className="text-muted-foreground text-xs">{help}</p> : null}
      <Textarea
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
}
